import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BarChartComponent } from '../../../my-shared-lib/src/lib/chart-components/bar-chart/bar-chart.component';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'opportunity-overview',
    pathMatch: 'full',
  },
  {
    path: 'opportunity-simulator',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opportunity-simulator-config.json' },
  },
  {
    path: 'opportunity-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opportunity-overview-config.json' },
  },
   {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },
  {
    path: 'sales-overview',
    component: BarChartComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'customer-overview',
    component: DashboardComponent,
    data: { configFile: 'customer-overview.json' },
    canActivate: [AuthGuard],
  },
    {
    path: 'cspec-bridge',
    component: DashboardComponent,
    data: { configFile: 'cspec-bridge.json' },
    canActivate: [AuthGuard],
    },
    {
    path: 'cspec-sales-bridge',
    component: DashboardComponent,
    data: { configFile: 'cspec-sales-bridge.json' },
    canActivate: [AuthGuard],
    },
    {
    path: '**',
    redirectTo: 'opportunity-overview',
  },
];
